import { Landmark, IndianRupee, Users, type LucideIcon } from "lucide-react";
import { imageAssetUrl } from "@/utils/url";
import { cn, ScrollArea } from "web-design-system";

export const STATS = [
  { icon: Users, value: "2000+", label: "MFDs Trust Creso" },
  { icon: Landmark, value: "40+", label: "AMC Partners" },
  { icon: IndianRupee, value: "300+ Cr", label: "AUM on Platform" },
];

export function StatItem({
  icon: Icon,
  value,
  label,
  className,
}: {
  icon: LucideIcon;
  value: string;
  label: string;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className="flex items-center justify-center shrink-0 size-9 rounded-lg bg-orange-50 text-orange-700">
        <Icon className="size-4" />
      </div>
      <div className="flex flex-col">
        <span className="font-semibold text-sm text-black">{value}</span>
        <span className="text-xs text-muted-foreground whitespace-nowrap">
          {label}
        </span>
      </div>
    </div>
  );
}

export function AuthSplitLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="h-dvh w-dvw bg-background sm:px-20 lg:px-56 xl:px-0 gap-12 xl:gap-6 sm:py-12 xl:py-0">
      <div className="flex flex-col xl:flex-row sm:border xl:border-0 border-border md:rounded-2xl h-full w-full overflow-hidden">
        <div
          className="flex xl:hidden shrink-0 flex-col gap-6 sm:gap-10 md:rounded-2xl bg-cover bg-center p-8"
          style={{ backgroundImage: `url(${imageAssetUrl("backdrop.png")})` }}
        >
          <div className="flex flex-wrap items-center gap-8 justify-between">
            <img
              src={imageAssetUrl("logo-dark.png")}
              alt="Creso"
              className="h-6 w-auto"
            />
            <div className="hidden sm:flex flex-wrap gap-8">
              {STATS.map((stat) => (
                <StatItem key={stat.label} {...stat} />
              ))}
            </div>
          </div>
          <div className="font-semibold leading-tight text-black text-2xl">
            <span className="hidden sm:block">
              Everything Mutual Fund Distributors
            </span>
            <span className="block sm:hidden">Everything MFDs</span>
            Need in <span className="text-orange-700">One Platform</span>
          </div>
        </div>

        <div
          className="hidden xl:flex shrink-0 flex-col py-16 px-20 bg-cover bg-center items-center w-[60%]"
          style={{ backgroundImage: `url(${imageAssetUrl("backdrop.png")})` }}
        >
          <div className="font-semibold leading-tight text-black text-2xl xl:text-3xl px-12 2xl:px-16 text-center">
            <div>Everything Mutual Fund Distributors</div>
            Need in <span className="text-orange-700">One Platform</span>
          </div>
          <div className="relative flex-1 min-h-0 w-full">
            <img
              src={imageAssetUrl("product-hero-image.png")}
              alt="Creso dashboard showing a distributor's client AUM, asset allocation, and mutual fund portfolio in one view."
              className="absolute inset-0 size-full object-contain"
            />
          </div>
          <div className="flex flex-row items-center gap-16 px-16">
            {STATS.map((stat) => (
              <StatItem key={stat.label} {...stat} />
            ))}
          </div>
        </div>

        <ScrollArea className="flex-1 min-h-0 w-full">
          <div className="flex flex-col gap-14 px-10 py-10 xl:px-6 xl:mx-auto w-full xl:max-w-md min-h-full justify-center">
            <img
              src={imageAssetUrl("logo-dark.png")}
              alt="Creso"
              className="h-6 w-24 hidden xl:block"
            />
            <div className="flex flex-col items-center h-full">{children}</div>
          </div>
        </ScrollArea>
      </div>
    </div>
  );
}
